<script setup>
import { shared } from './shared.js'
</script>

<template>
    <div v-if="deviceDetail.acsa" class="card" style="margin-bottom: 20px;">
        <div class="card-header" style="background-color:#fff3cd">
            <div class="form-check form-check-inline float-end" v-if="check_protocol()">
                <input class="form-check-input" type="checkbox" v-model="show_raw">
                <label class="form-label" style="margin-bottom: 0px;">Show raw</label>
            </div>
            <h5 style="margin-bottom: 0px;">
                <i v-if="deviceDetail.acsa.status == 'updating'" class="bi bi-cloud-arrow-down-fill text-info"></i>
                <i v-else-if="deviceDetail.acsa.status == 'online'" class="bi bi-activity text-primary"></i>
                <i v-else class="bi bi-heartbreak-fill text-danger"></i>
                ACSA
            </h5>
        </div>
        <div class="card-body" v-show="show_raw" style="padding: 0;">
            <Vue3JsonEditor
                class="json-raw-viewer"
                v-model="deviceDetail.acsa.data"
                :show-btns="false"
                :mode="'view'"
                :expandedOnStart="true"/>
        </div>
        <div v-if="deviceDetail.acsa.status == 'updating'" class="card-body"> <div class="alert alert-info" style="margin-bottom:0">Firmware update in progress</div></div>
        <div v-else-if="check_protocol() && shared.check_any_live_data(deviceDetail.acsa)" class="card-body" :style="{ 'opacity': (deviceDetail.acsa.status == 'online' && !shared.check_any_device_updating(deviceDetail) ? 100 : 25) + '%' }">
            <h5>Control</h5>
            <table class="table table-sm">
                    <thead class="text-end">
                        <tr>
                            <th></th>
                            <th width="100px">Setpoint</th>
                            <th width="100px">Actual</th>
                            <th width="160px"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="check_minimum_firmware_version(2,0) == false">
                            <td>Cluster power mode</td>
                            <td></td>
                            <td class="fw-bold text-end">{{ get_data("cluster.power_mode.mode") }}</td>
                            <td v-if="shared.allow_control">
                                <div class="input-group input-group-sm">
                                    <select v-model="target_cluster_power_mode" class="form-select">
                                        <option value="1">1: ACS</option>
                                        <option value="2">2: EXT_REF</option>
                                        <option value="3">3: IREF</option>
                                    </select>
                                    <button type="button" class="btn btn-outline-danger" @click="writeParameter('cluster.power_mode.mode', target_cluster_power_mode)">></button>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="check_minimum_firmware_version(2,0) == true">
                            <td>Cluster power mode</td>
                            <td></td>
                            <td class="fw-bold text-end">{{ get_data('cluster.power.mode') }}</td>
                            <td v-if="shared.allow_control">
                                <div class="input-group input-group-sm">
                                    <select v-model="target_cluster_power_mode" class="form-select">
                                        <option value="0">0: OFF</option>
                                        <option value="1">1: PGRID_REF</option>
                                        <option value="2">2: PCLUSTER_REF</option>
                                    </select>
                                    <button type="button" class="btn btn-outline-danger" @click="writeParameter('cluster.power.mode', target_cluster_power_mode)">></button>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="check_minimum_firmware_version(2,0) == false && (target_cluster_power_mode == 2 || get_data('cluster.power_mode.mode') == 2)">
                            <td>Grid power setpoint</td>
                            <td></td>
                            <td class="fw-bold text-end">{{ get_data("cluster.power_mode.ext_ref", 0) }} W</td>
                            <td v-if="shared.allow_control">
                                <div class="input-group input-group-sm">
                                    <input class="form-control" v-model="target_cluster_ext_ref"
                                        v-on:keyup.enter="writeParameter('cluster.power_mode.ext_ref', target_cluster_ext_ref)" />
                                    <button type="button" class="btn btn-outline-danger"
                                        @click="writeParameter('cluster.power_mode.ext_ref', target_cluster_ext_ref)">></button>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="check_minimum_firmware_version(2,0) == false && (target_cluster_power_mode == 3 || get_data('cluster.power_mode.mode') == 3)">
                            <td>AC Current setpoint (open-loop) - d</td>
                            <td></td>
                            <td class="fw-bold text-end">{{ get_data("cluster.power_mode.iref.d") }} A</td>
                            <td v-if="shared.allow_control">
                                <div class="input-group input-group-sm">
                                    <input class="form-control" v-model="target_cluster_iref_d"
                                        v-on:keyup.enter="writeParameter('cluster.power_mode.iref.d', target_cluster_iref_d)" />
                                    <button type="button" class="btn btn-outline-danger"
                                        @click="writeParameter('cluster.power_mode.iref.d', target_cluster_iref_d)">></button>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="check_minimum_firmware_version(2,0) == false && (target_cluster_power_mode == 3 || get_data('cluster.power_mode.mode') == 3)">
                            <td>AC Current setpoint (open-loop) - q</td>
                            <td></td>
                            <td class="fw-bold text-end">{{ get_data("cluster.power_mode.iref.q") }} A</td>
                            <td v-if="shared.allow_control">
                                <div class="input-group input-group-sm">
                                    <input class="form-control" v-model="target_cluster_iref_q"
                                        v-on:keyup.enter="writeParameter('cluster.power_mode.iref.q', target_cluster_iref_q)" />
                                    <button type="button" class="btn btn-outline-danger"
                                        @click="writeParameter('cluster.power_mode.iref.q', target_cluster_iref_q)">></button>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="check_minimum_firmware_version(2,0) == true && (target_cluster_power_mode == 1 || get_data('cluster.power.mode') > 0)">
                            <td>Grid (active) power reference</td>
                            <td class="text-end">{{ get_data('cluster.power.pref_grid.setpoint', 0) }} W</td>
                            <td class="fw-bold text-end">{{ get_data('cluster.power.pref_grid.actual', 0) }} W</td>
                            <td v-if="shared.allow_control">
                                <div class="input-group input-group-sm">
                                    <input class="form-control" v-model="target_pref_grid" v-on:keyup.enter="writeParameter('cluster.power.pref_grid.setpoint', target_pref_grid)" />
                                    <button type="button" class="btn btn-outline-danger" @click="writeParameter('cluster.power.pref_grid.setpoint', target_pref_grid)">></button>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="check_minimum_firmware_version(2,0) == true && (target_cluster_power_mode == 2 || get_data('cluster.power.mode') == 2)">
                            <td>Cluster (active) power reference</td>
                            <td class="text-end">{{ get_data('cluster.power.pref_cluster.setpoint', 0) }} W</td>
                            <td class="fw-bold text-end">{{ get_data('cluster.power.pref_cluster.actual', 0) }} W</td>
                            <td v-if="shared.allow_control">
                                <div class="input-group input-group-sm">
                                    <input class="form-control" v-model="target_pref_cluster"
                                        v-on:keyup.enter="writeParameter('cluster.power.pref_cluster.setpoint', target_pref_cluster)" />
                                    <button type="button" class="btn btn-outline-danger" @click="writeParameter('cluster.power.pref_cluster.setpoint', target_pref_cluster)">></button>
                                </div>
                            </td>
                        </tr>
                        <tr class="table-group-divider" v-if="shared.allow_control">
                            <td>Party mode (force autonomous)</td>
                            <td></td>
                            <td></td>
                            <td>
                                <div class="input-group input-group-sm">
                                    <select v-model="target_party_mode" class="form-select">
                                        <option value="0">0: Disable</option>
                                        <option value="1">1: Enable</option>
                                    </select>
                                    <button type="button" class="btn btn-outline-danger"
                                        @click="writeParameter('homegrid_connect.party_mode', target_party_mode)">></button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
            </table>

            <!-- TODO: this table is mostly for debug purposes, maybe add a checkbox to show it -->
            <table class="table table-sm text-end" v-if="check_minimum_firmware_version(2,0) == true">
                <thead>
                    <tr>
                        <th width="300px"></th>
                        <th class="text-center" width="100px">L1</th>
                        <th class="text-center" width="100px">L2</th>
                        <th class="text-center" width="100px">L3</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="text-start fw-bold">Gridcode - reactive power</td>
                        <td class="text-start" colspan="3"><small>{{ get_descriptive("gc.reactive_power.status.l1", 0) }}</small></td>
                    </tr>
                    <tr>
                        <td class="text-start">Setpoint</td>
                        <td>{{ get_data("gc.reactive_power.actual_setpoint.l1", 0) }} var</td>
                        <td>{{ get_data("gc.reactive_power.actual_setpoint.l2", 0) }} var</td>
                        <td>{{ get_data("gc.reactive_power.actual_setpoint.l3", 0) }} var</td>
                    </tr>
                    <tr style="height:10px"></tr>
                    <tr>
                        <td class="text-start fw-bold">Gridcode - active power</td>
                        <td class="text-start " colspan="3"><small>{{ get_descriptive("gc.active_power.status.l1", 0) }}</small></td>
                    </tr>
                    <tr>
                        <td class="text-start">Charge limit</td>
                        <td>{{ get_data("gc.active_power.actual_charge_limit.l1", 0) }} W</td>
                        <td>{{ get_data("gc.active_power.actual_charge_limit.l2", 0) }} W</td>
                        <td>{{ get_data("gc.active_power.actual_charge_limit.l3", 0) }} W</td>
                    </tr>
                    <tr>
                        <td class="text-start">Discharge limit</td>
                        <td>{{ get_data("gc.active_power.actual_discharge_limit.l1", 0) }} W</td>
                        <td>{{ get_data("gc.active_power.actual_discharge_limit.l2", 0) }} W</td>
                        <td>{{ get_data("gc.active_power.actual_discharge_limit.l3", 0) }} W</td>
                    </tr>
                    <tr style="height:10px"></tr>
                    <tr>
                        <td class="text-start fw-bold">Cluster power control</td>
                        <td class="text-start " colspan="3"><small>{{ get_descriptive("pwr_ctrl.status") }}</small></td>
                    </tr>
                    <tr>
                        <td class="text-start">Active power reference</td>
                        <td>{{ get_data("cluster.pref_cluster_actual.l1", 0) }} W</td>
                        <td>{{ get_data("cluster.pref_cluster_actual.l2", 0) }} W</td>
                        <td>{{ get_data("cluster.pref_cluster_actual.l3", 0) }} W</td>
                    </tr>
                    <tr>
                        <td class="text-start">Reactive power reference</td>
                        <td>{{ get_data("cluster.qref_cluster_actual.l1", 0) }} var</td>
                        <td>{{ get_data("cluster.qref_cluster_actual.l2", 0) }} var</td>
                        <td>{{ get_data("cluster.qref_cluster_actual.l3", 0) }} var</td>
                    </tr>
                </tbody>
            </table>

            <h5>System details</h5>
            <table class="table table-sm">
                <thead>
                    <tr>
                        <th width="250px"></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>State</td>
                        <td class="fw-bold">{{ get_descriptive_quick("system.state") }}</td>
                    </tr>
                    <tr>
                        <td>Status</td>
                        <td class="fw-bold">{{ get_descriptive_quick("system.status") }}</td>
                    </tr>
                    <tr>
                        <td>Warning</td>
                        <td class="fw-bold">{{ get_descriptive_quick("system.warning") }}</td>
                    </tr>
                    <tr>
                        <td>Error</td>
                        <td class="fw-bold">{{ get_descriptive_quick("system.error") }}</td>
                    </tr>
                    <tr>
                        <td>Critical</td>
                        <td>{{ get_descriptive("system.critical") }}</td>
                    </tr>
                    <tr class="table-group-divider">
                        <td>Autonomous</td>
                        <td>{{ get_data("system.autonomous") }}</td>
                    </tr>
                    <tr class="table-group-divider">
                        <td>Homegrid disconnect status</td>
                        <td>{{ get_descriptive('homegrid_disconnect.status') }}</td>
                    </tr>
                    <tr>
                        <td>Homegrid connect status</td>
                        <td>{{ get_descriptive('homegrid_connect.status') }} </td>
                    </tr>
                    <tr>
                        <td>Homegrid connect time remaining</td>
                        <td>{{ get_data("homegrid_connect.time_remaining") }} ms</td>
                    </tr>
                </tbody>
            </table>
            <h5>Measurements</h5>
            <table class="table table-sm text-end">
                <thead>
                    <tr>
                        <th></th>
                        <th class="text-center" width="100px">L1</th>
                        <th class="text-center" width="100px">L2</th>
                        <th class="text-center" width="100px">L3</th>
                        <th class="text-center" width="100px">Sum</th>
                    </tr>
                </thead>
                <tbody class="table-group-divider">
                    <tr>
                        <td class="text-start">Voltage (public grid)</td>
                        <td>{{ get_data("avg.vgrid_l1",1) }} V</td>
                        <td>{{ get_data("avg.vgrid_l2",1) }} V</td>
                        <td>{{ get_data("avg.vgrid_l3",1) }} V</td>
                        <td>{{ get_data("avg.fgrid",2) }} Hz</td>
                    </tr>
                    <tr>
                        <td class="text-start">Voltage (home grid)</td>
                        <td class="fw-bold">{{ get_data_quick("avg.vhome_l1",1) }} V</td>
                        <td class="fw-bold">{{ get_data_quick("avg.vhome_l2",1) }} V</td>
                        <td class="fw-bold">{{ get_data_quick("avg.vhome_l3",1) }} V</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td class="text-start">Current</td>
                        <td class="fw-bold">{{ get_data_quick("avg.igrid_l1",2) }} A</td>
                        <td class="fw-bold">{{ get_data_quick("avg.igrid_l2",2) }} A</td>
                        <td class="fw-bold">{{ get_data_quick("avg.igrid_l3",2) }} A</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td class="text-start">Active power</td>
                        <td class="fw-bold">{{ get_data_quick("avg.pgrid_l1",0) }} W</td>
                        <td class="fw-bold">{{ get_data_quick("avg.pgrid_l2",0) }} W</td>
                        <td class="fw-bold">{{ get_data_quick("avg.pgrid_l3",0) }} W</td>
                        <td class="fw-bold">{{ get_data_quick("avg.pgrid_sum",0) }} W</td>
                    </tr>
                    <tr>
                        <td class="text-start">Reactive power</td>
                        <td>{{ get_data("avg.qgrid_l1",0) }} var</td>
                        <td>{{ get_data("avg.qgrid_l2",0) }} var</td>
                        <td>{{ get_data("avg.qgrid_l3",0) }} var</td>
                        <td class="fw-bold">{{ get_data_quick("avg.qgrid_sum",0) }} var
                        </td>
                    </tr>
                    <tr>
                        <td class="text-start">Apparent power</td>
                        <td>{{ get_data("avg.sgrid_l1",0) }} VA</td>
                        <td>{{ get_data("avg.sgrid_l2",0) }} VA</td>
                        <td>{{ get_data("avg.sgrid_l3",0) }} VA</td>
                        <td class="fw-bold">{{ get_data_quick("avg.sgrid_sum",0) }} VA
                        </td>
                    </tr>
                    <tr>
                        <td class="text-start">Power factor</td>
                        <td>{{ get_data("avg.pfgrid_l1",3)  }}</td>
                        <td>{{ get_data("avg.pfgrid_l2",3) }}</td>
                        <td>{{ get_data("avg.pfgrid_l3",3) }}</td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div v-else class="card-body"> <div class="alert alert-warning" style="margin-bottom:0">No data</div></div>
    </div>
</template>

<script>
export default {
    props: ['deviceDetail', 'client'],
    setup() { },
    data() {
        return {
            show_raw: 0,

            target_cluster_power_mode: 1,
            target_cluster_ext_ref: 0,
            target_cluster_iref_d: 0,
            target_cluster_iref_q: 0,

            target_pref_grid: 0,
            target_pref_cluster: 0,
            target_qref_cluster: 0,

            target_party_mode: 0,
        };
    },
    methods: {
        check_minimum_firmware_version(major, minor) {
            // Check if firmware is above certain version
            let version_minimum = (major << 24) | (minor << 16);
            let current_version = shared.get_nested_value_safely(this.deviceDetail.acsa.data, "version.firmware", 0)
            if (current_version == "-" || parseInt(current_version) < version_minimum) {
                return false;
            } else {
                return true;
            }
        },
        check_protocol() {
            return this.deviceDetail.info && this.deviceDetail.info.protocol_version != null
        },
        get_data(parameter, round = null) {
            return shared.get_nested_value_safely(this.deviceDetail.acsa.data, parameter, round)
        },
        get_data_quick(parameter, round = null) {
            return shared.get_nested_value_safely(this.deviceDetail.acsa.data_quick, parameter, round)
        },
        get_descriptive(parameter) {
            return shared.get_descriptive_safely(this.deviceDetail.acsa.data, parameter)
        },
        get_descriptive_quick(parameter) {
            return shared.get_descriptive_safely(this.deviceDetail.acsa.data_quick, parameter)
        },
        writeParameter(parameter, value) {
            var topic = this.deviceDetail.topic_base + "/" + this.deviceDetail.serial + "/request"
            var payload = {
                function: "write_parameter",
                target: "acsa",
                parameter: parameter,
                value: value,
            }
            console.log({ topic: topic, payload: payload })
            this.client.publish(topic, JSON.stringify(payload), error => {
                if (error) {
                    console.log('Publish error', error)
                }
            })
        }
    },
    created() {
        if (this.deviceDetail.info.protocol_version == null) {
            this.show_raw = 1;
        }
    },
};
</script>